import { render } from "./MyProjectPage.vue?vue&type=template&id=70d3377b"
import script from "./MyProjectPage.vue?vue&type=script&lang=js"
export * from "./MyProjectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__